/**
 * @prettier
 */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import '../style/lgy-her0.scss'

import LgyModalDialog from 'app/components/util/lgy-modal-dialog/LgyModalDialog'

import externalLink from 'uswds/dist/img/external-link-alt.svg'

const LgyHero = ({ serverProperties, sahshaToggle }) => {
  const [showSignInModal, setShowSignInModal] = useState(false)
  const [showShasha, setShowShasha] = useState(false)

  const handleSignIn = () => {
    setShowSignInModal(true)
  }

  useEffect(() => {
    let val
    if (sahshaToggle.value) {
      val = 'true' === sahshaToggle.value.toLowerCase()
    }
    setShowShasha(val)
  }, [sahshaToggle])

  return (
    <div>
      <LgyModalDialog show={showSignInModal}>
        <div className='modal-dialog usa-grid'>
          <h4 className='modal-dialog-text'>Sign In with Access VA</h4>
          <p className='usa-content'>
            Select continue to go to AccessVA. Internal VA users and VSOs should choose "Sign in with VA PIV card." All
            others should choose "Sign in with ID.me." You will then be redirected back to Loan Guaranty.
          </p>
          <hr />
          <a href={`${serverProperties.eauthUrl}/accessva/?appId=lgyhub`} class='usa-button modal-dialog-text'>
            {' '}
            Continue{'  '}
            <img className='image-external-link' src={externalLink} alt='external link for LGY login' />
          </a>
        </div>
      </LgyModalDialog>
      <div className='lgy-hero'>
        <section className='usa-hero'>
          <div className='usa-grid'>
            <div className='lgy-hero-notice usa-hero-callout usa-section-dark'>
              <h2>
                <span className='usa-hero-callout-alt'>LGY Hub</span>
              </h2>
              <p>Access VA Loan Guaranty applications, such as WebLGY, Appraiser Gear, etc.</p>
              <div className='lgy-sign-in-register-link'>
                <button className='lgy-header-sign-in' onClick={handleSignIn}>
                  Sign in or register for the LGY Hub
                </button>
              </div>
            </div>
            <div className='usa-hero-callout usa-section-dark ppm-hero-notice '>
              <h2>
                <span className='usa-hero-callout-alt'>PPM</span>
              </h2>
              <p>
                Program Participant Management Portal used by lender VA relationship managers (VARMs) to submit lender
                application requests, process renewals, and update lender profile information.
              </p>
              <div className='ppm-sign-in-register-link'>
                <a href={serverProperties.ppmEauthUrl} className='usa-button modal-dialog-text'>
                  {' '}
                  Sign in or register with ID.me
                </a>
              </div>
              <div className='ppm-sign-in-register-link'>
                <a href={serverProperties.ppmPivEauthUrl} className='usa-button modal-dialog-text'>
                  {' '}
                  Sign in with PIV (For VA Employees)
                </a>
              </div>
            </div>
            <div className='usa-hero-callout usa-section-dark ffps-hero-notice'>
              <h2>
                <span className='usa-hero-callout-alt'>FFPS</span>
              </h2>
              <p>Funding Fee Payment System used to process funding fee payments and refunds on guaranteed loans.</p>
              <div className='ffps-sign-in-register-link'>
                <button className='lgy-header-sign-in' onClick={handleSignIn}>
                  Sign in for VA Funding Fee Payment System
                </button>
              </div>
            </div>
            {showShasha && (
              <div className='usa-hero-callout usa-section-dark sahsha-hero-notice'>
                <h2>
                  <span className='usa-hero-callout-alt'>SAH</span>
                </h2>
                <p>
                  Builders and Compliance Inspectors (CI) portals used to process Specially Adapted Housing (SAH),
                  Special Housing Adaptation (SHA), and Independent Living (IL) grants.
                </p>
                <div className='sahsha-sign-in-register-link'>
                  <a href={serverProperties.sahInspectorUrl} className='usa-button modal-dialog-text'>
                    {' '}
                    Sign in to access the CI Portal
                  </a>
                </div>
                <div className='sasha-sign-in-register-link sasha-hero-middle-button'>
                  <a href={serverProperties.sahBuilderUrl} className='usa-button modal-dialog-text'>
                    {' '}
                    Sign in to access the Builder Portal
                  </a>
                </div>
                <div className='sahsha-sign-in-register-link'>
                  <a href={serverProperties.sahPortalUrl} className='usa-button modal-dialog-text'>
                    {' '}
                    Sign in with PIV (For VA Employees)
                  </a>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  serverProperties: state.serverProperties ? state.serverProperties : {},
  sahshaToggle: state.sahshaToggle
})
export default connect(mapStateToProps)(LgyHero)
